import { render, staticRenderFns } from "./DocumentosDeMovimientos.vue?vue&type=template&id=1cba9aa0&"
import script from "./DocumentosDeMovimientos.vue?vue&type=script&lang=js&"
export * from "./DocumentosDeMovimientos.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosDeMovimientos.vue?vue&type=style&index=0&id=1cba9aa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports